import { IconCheck } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

import Dot from '@/components/Dot/Dot';
import { ValidationResult } from '@/models/Validation';

export type ValidationTooltipLineProps = Omit<ValidationResult<string>, 'key'>;

const PasswordTooltipLine = ({ description, isInvalid }: ValidationTooltipLineProps) => (
  <Box display="flex" gap="8" alignItems="center">
    {isInvalid && (
      <Box display="flex" justifyContent="center" alignItems="center" flexBasis="1">
        <Dot size="6" backgroundColor="color/neutral/muted" />
      </Box>
    )}
    {!isInvalid && <IconCheck size="16" color="icon/positive" flexBasis="16px" flexShrink="0" />}
    <Text textStyle="body/md/regular" color={isInvalid ? 'text/secondary' : 'text/primary'}>
      {description}
    </Text>
  </Box>
);

export type ValidationTooltipProps = {
  id?: string;
  /** Leave it out where a container already titles the list, such as a popover. */
  title?: string;
  results: ValidationResult<string>[];
};

const ValidationTooltip = ({ id, title, results }: ValidationTooltipProps) => {
  return (
    <Box display="flex" flexDirection="column" gap="8" id={id} maxWidth={['100%', '300px']}>
      {!!title && (
        <Text textStyle="sans/size-2/bold" color="text/primary">
          {title}
        </Text>
      )}
      {results.map(({ key, description, isInvalid }) => (
        <PasswordTooltipLine key={key} description={description} isInvalid={isInvalid} />
      ))}
    </Box>
  );
};

export default ValidationTooltip;
